<template>
  <div>
    <div :key="trx.id" v-for="trx in data">
      <div
        v-if="leadInfos"
        class="bg-white rounded-lg divide-y md:divide-y-0 md:divide-x border  mt-4 flex flex-col md:flex-row"
      >
        <div class=" p-4 flex-2 flex justify-start  space-x-2">
          <div>
            <div>
              <div class="mb-1">
                <span
                  v-if="trx.type == 'YATIRIM'"
                  class="px-2 py-1 text-xs font-semibold text-green-800 bg-green-100 rounded-full"
                  >{{ trx.type }}</span
                >
                <span
                  v-else
                  class="px-2 py-1 text-xs font-semibold text-red-800 bg-red-100 rounded-full"
                  >ÇEKİM</span
                >
              </div>

              <div class="text-lg font-medium text-gray-900">
           <div class="flex   items-center space-x-2">     <router-link
                  v-if="leadInfos"
                  :to="'/leadDetail/' + trx.customer_id + '?trx=' + trx.id"
                  class="  font-medium text-black"
                >
                  <template v-if="getleadInfo(trx.customer_id, 'name')">
                    {{ getleadInfo(trx.customer_id, "name") }}
                  </template>
                </router-link>


               <span class=" border rounded-lg px-2 text-xs">{{ $root.getVal(199, trx.gateway_id) }}</span></div>

              </div>
            </div>
            <div class="flex items-start justify-start">
              <div class="">
                <div class="text-xl font-semibold text-gray-900">
                  <div class="text-xs uppercase font-light text-gray-400">
                    TALEP EDİLEN:
                  </div>
                  <div class="w-40">
                    {{ trx.amount }} {{ $root.getVal(148, trx.currency_id) }}
                  </div>
                </div>
              </div>
              <div class="">
                <div class="text-xl font-semibold text-gray-900">
                  <div class="text-xs uppercase font-light text-gray-400">
                    BANKAYA İŞLENEN:
                  </div>
                  <div class="w-40">
                    {{ trx.amount_bank }}
                    {{ $root.getVal(148, trx.bank_currency_id) }}
                  </div>
                </div>
              </div>
              <div class="">
                <div class="text-xl font-semibold text-gray-900">
                  <div class="text-xs uppercase font-light text-gray-400">
                    PLATFORMA İŞLENEN:
                  </div>
                  <div class="w-40">
                    {{ trx.amount_platform }}
                    {{ $root.getVal(148, trx.platform_currency_id) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-1 flex-col   border-l pl-2 md:divide-y">
            <div class="flex flex-col md:flex-row  md:space-x-2">
              <div>
                <div class="text-xs uppercase font-light text-gray-400">
                  PLATFORM:
                </div>
                <router-link
                  :to="
                    '/leadDetail/' +
                      trx.customer_id +
                      '?trx=' +
                      trx.id +
                      '#platformlar'
                  "
                  class="text-lg font-medium text-black"
                  >{{ trx.login }}</router-link
                >
              </div>

              <div>
                <div class="text-xs uppercase font-light text-gray-400">
                  OLUŞTURULMA TARİHİ:
                </div>
                <div class="text-sm font-medium text-black">
                  {{ trx.created_at }}
                </div>
              </div>
              <div v-if="leadInfos">
                <div
                  class="text-xs noselect uppercase font-light text-gray-400"
                >
                  TELEFON NUMARASI:
                </div>
                <div class="text-sm noselect font-medium text-black">
                  {{ getleadInfo(trx.customer_id, "phone") }}
                </div>
              </div>
              <div v-if="leadInfos">
                <div class="text-xs uppercase font-light text-gray-400">
                  T.C:
                </div>
                <div class="text-sm font-medium text-black">
                  {{ getleadInfo(trx.customer_id, "tc") }}
                </div>
              </div>
            </div>
            <div class="flex pt-2">
              <div v-if="leadInfos" class="flex items-start  space-x-2">
                <div class="flex flex-col">
                  <div class="text-xs uppercase font-light text-gray-400">
                    ADRES:
                  </div>
                  <div class="text-xs font-medium text-black">
                    {{ getleadInfo(trx.customer_id, "address") }} <br />
                    {{ getleadInfo(trx.customer_id, "ilce") }} ,
                    {{ getleadInfo(trx.customer_id, "city") }}

                    <div v-if="trx.lead_remitter_id > 1" class="">
                      <router-link
                        :to="
                          '/leadDetail/' +
                            trx.customer_id +
                            '?trx=' +
                            trx.id +
                            '#3-sahis-bilgileri'
                        "
                        class="inline-flex bg-tile-50 bg-opacity-30 space-x-2 border border-tile-400 rounded-lg p-1 text-tile-700"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="w-4 h-4 text-tile"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M17 21.025q-.2 0-.4-.05t-.375-.175l-3-1.75q-.35-.2-.537-.537t-.188-.738V14.25q0-.4.188-.737t.537-.538l3-1.75q.175-.125.375-.175T17 11q.2 0 .388.063t.362.162l3 1.75q.35.2.55.538t.2.737v3.525q0 .4-.2.738t-.55.537l-3 1.75q-.175.1-.363.163t-.387.062M10 12q-1.65 0-2.825-1.175T6 8q0-1.65 1.175-2.825T10 4q1.65 0 2.825 1.175T14 8q0 1.65-1.175 2.825T10 12m-8 8v-2.8q0-.825.425-1.55t1.175-1.1q1.275-.65 2.875-1.1T10 13h.35q.15 0 .3.05q-.2.45-.337.938T10.1 15H10q-1.775 0-3.187.45t-2.313.9q-.225.125-.363.35T4 17.2v.8h6.3q.15.525.4 1.038t.55.962zm8-10q.825 0 1.413-.587T12 8q0-.825-.587-1.412T10 6q-.825 0-1.412.588T8 8q0 .825.588 1.413T10 10m4.65 3.85L17 15.225l2.35-1.375L17 12.5zm3.1 5.2l2.25-1.3V15l-2.25 1.325zM14 17.75l2.25 1.325V16.35L14 15.025z"
                          />
                        </svg>

                        <span>Üçüncü şahış aracılığı var</span></router-link
                      >
                    </div>
                  </div>
                </div>
                <div class="flex flex-col">
                  <div class="text-xs uppercase font-light text-gray-400">
                    E-POSTA: 
                  </div>
                  <div class="text-xs font-medium text-black">
                    {{ getleadInfo(trx.customer_id, "email") }}
                  </div>
                </div>
                <div class="flex flex-col">
                  <div class="text-xs uppercase font-light text-gray-400">
                    İŞLEM NO:
                  </div>
                  <div class="text-xs font-medium text-black">
                    {{ trx.id }}
                  </div>
                </div>
                <div class="flex   pr-2 flex-col">
                  <div class="text-xs uppercase font-light text-gray-400">
                    RETENTION:
                  </div>
                  <div class="text-xs font-medium text-black">
                    {{ $root.getVal(15, trx.retention_id) }}
                  </div>
                </div>
                <div class="flex  flex-col">
                  <div class="text-xs uppercase font-light text-gray-400">
                    TEMSİLCİ:
                  </div>
                  <div class="text-xs font-medium text-black">
                    {{ $root.getVal(15, trx.agent_id) }}
                  </div>
                </div>
                <div class="flex flex-col">
                  <div class="text-xs uppercase font-light text-gray-400">
                    OLUŞTURAN :
                  </div>
                  <div class="text-xs font-medium text-black">
                    {{ $root.getVal(15, trx.insert_user_id) }}
                    <template v-if="trx.team_id > 1">
                   ({{ $root.getVal(58, trx.team_id) }})
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-4 text-xs ">
          <div>
            {{ $root.getVal(146, trx.status_id) }}
            <div v-if="trx.comment" class="border rounded-lg p-2"><b>Not:</b> {{  trx.comment }}</div>

            <ChangeStatus :trx="trx" />

            <Finance :trx="trx" v-if="$root.cache.me.department == 'finance'" />
            <Risk :trx="trx" v-if="$root.cache.me.department == 'risk'" />
            <a
              :href="'/list/transactions?id=' + trx.id"
              v-if="
                $root.cache.me.department == 'admin' ||
                  $root.cache.me.department == 'sales_manager'
              "
              class="text-xs"
              >Detay</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Finance from "../TransactionModals/Finance.vue";
import Risk from "../TransactionModals/Risk.vue";
import ChangeStatus from "../TransactionModals/Forms/ChangeStatus.vue";
import http from "../../services/http";
import EventBus from "../Ui/EventBus";

export default {
  props: ["data"],
  data() {
    return {
      form: [],
      transactions: [],
      leadInfos: [],

      selectedFilter: null,
      activeTab: "bekleyen",
    };
  },
  created() {
    EventBus.$emit("loading", true);
    this.$emit("loading", true);

    Promise.all(
      this.data.map((trx) => {
        return http.transaction.leadInfo(trx.customer_id, trx.id);
      })
    )
      .then((responses) => {
        responses.forEach((response) => {
          if (response.data.result.id) {
            this.leadInfos.push(response.data.result);
          }
        });
      })
      .finally(() => {
        this.$emit("loading", false);
        EventBus.$emit("loading", false);
      });
  },
  methods: {
    getleadInfo(itemId, key) {
      const res = this.leadInfos.find((e) => e.id == itemId);
      if (res) {
        return res[key];
      } else {
        return false;
      }
      //   return this.leadInfos.find((e) => e.id == itemId)[key];
    },
  },
  components: { Finance, Risk, ChangeStatus },
};
</script>
